/**
 * Automation API Service
 * Handles BlueSky posting and webhook integrations
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const automationApi = {
  // Get automation settings for a user
  getSettings: async (userId) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/settings/${userId}`);
    if (!response.ok) throw new Error('Failed to get automation settings');
    return response.json();
  },

  // BlueSky Methods
  connectBlueSky: async (userId, handle, appPassword) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/bluesky/connect`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        handle,
        app_password: appPassword
      })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.detail || 'Failed to connect BlueSky');
    return data;
  },

  disconnectBlueSky: async (userId) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/bluesky/disconnect?user_id=${userId}`, {
      method: 'POST'
    });
    if (!response.ok) throw new Error('Failed to disconnect BlueSky');
    return response.json();
  },

  postToBlueSky: async (userId, text, imageUrl = null) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/bluesky/post`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        text,
        image_url: imageUrl
      })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to post to BlueSky');
    return data;
  },

  // Webhook Methods
  configureWebhook: async (userId, webhookUrl, webhookSecret = null) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/webhook/configure`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        webhook_url: webhookUrl,
        webhook_secret: webhookSecret
      })
    });
    if (!response.ok) throw new Error('Failed to configure webhook');
    return response.json();
  },

  testWebhook: async (userId) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/webhook/test`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Webhook test failed');
    return data;
  },

  triggerWebhook: async (userId, postData) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/webhook/trigger`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        post_data: postData
      })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to trigger webhook');
    return data;
  },

  removeWebhook: async (userId) => {
    const response = await fetch(`${BACKEND_URL}/api/automation/webhook?user_id=${userId}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to remove webhook');
    return response.json();
  }
};

export default automationApi;
